<template>
    <v-container fluid fill-height>
        <v-layout align-center >
            <v-flex xs12 text-xs-center>
                <h4>Ops... Esta página não existe</h4>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import usuarioHelper from '@/helpers/usuario-logado';

export default {
  name: 'NaoExiste',
  mounted: function() {
    this.processarOrigem();
  },
  methods: {
    processarOrigem: function() {
      const self = this;
      if (self.$router.currentRoute.fullPath == '/' && usuarioHelper.USUARIO_LOGADO()) {
        self.$router.push({name: 'ListagemSolicitacoes'});
      } else if (self.$router.currentRoute.fullPath == '/') {
        self.$router.push({name: 'Questionario'});
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/paginas-informativas/NaoExiste.vue